/**
 * Environment-aware logger. Logs in development, silent in production.
 */
const isDev = process.env.NODE_ENV !== "production";

/* eslint-disable no-console */
export const logger = {
  error: (...args) => {
    if (isDev) console.error(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  log: (...args) => {
    if (isDev) console.log(...args);
  },
};
/* eslint-enable no-console */
